import React from 'react';
import { Icon, Typography } from 'components/common';

export type StatCardIconVariant = 'blue' | 'purple';

const ICON_VARIANT_MAP: Record<
	StatCardIconVariant,
	{ colorClass: string; bg: string }
> = {
	blue: { colorClass: 'text-main-blue-dark', bg: '#2D41F51F' },
	purple: { colorClass: 'text-primary', bg: '#8039DF1F' },
};

export interface StatCardProps {
	icon: string;
	value: string;
	label: string;
	description: string;
	iconVariant?: StatCardIconVariant;
}

export const StatCard: React.FC<StatCardProps> = ({
	icon,
	value,
	label,
	description,
	iconVariant = 'purple',
}) => {
	const { colorClass, bg } = ICON_VARIANT_MAP[iconVariant];

	return (
		<div
			className="flex flex-col gap-1 p-5 max-w-[266px] h-[173px] 3xl:max-w-none 3xl:w-auto rounded-2xl border border-white backdrop-blur-sm"
			style={{
				background: '#FFFFFFCC',
				boxShadow: '0px 1px 2px 0px #0000000D',
			}}
		>
			<span
				className="size-10 rounded-full flex justify-center items-center mb-2"
				style={{ background: bg }}
			>
				<Icon src={icon} width={18} height={18} className={colorClass} />
			</span>
			<Typography
				type="bold-24"
				className="text-black !text-2xl leading-[150%]"
			>
				{value}
			</Typography>
			<Typography
				type="semibold-14"
				className="text-black !text-sm leading-[150%]"
			>
				{label}
			</Typography>
			<Typography type="regular-12" className="text-gray-35 leading-[150%]">
				{description}
			</Typography>
		</div>
	);
};
